export default "__VITE_ASSET__CFewIDVh__"